import axios from 'axios';
import { GET_POPULARORPERSONAL_EVENTS_REQUEST, GET_POPULARORPERSONAL_EVENTS_SUCCESS, GET_POPULARORPERSONAL_EVENTS_FAILURE } from 'Store/constants';
import EnvironmentManager from 'Utils/environmentManager';

export const getPopularOrPersonalEventsByTabType = ({ tabType, bulletinType, isPersonal = false }) => async (dispatch, getState) => {

  try {
    dispatch({
      type: GET_POPULARORPERSONAL_EVENTS_REQUEST,
      payload: { isPersonal }
    });

    const liveEventsEnabledSwitch = EnvironmentManager.getMessageText({ key: 'live_bet_switch_visibility' }) === 'true';

    let params = {
      tabType,
      bulletinType,
    };

    if (liveEventsEnabledSwitch) {
      params.liveEventsEnabledForPreBulletin = true;
    }

    let gameListUrl = '/v3/mobile/aggregator/gamelist/events/popular';

    if (isPersonal) {
      gameListUrl = '/v3/mobile/aggregator/gamelist/auth/events/recommended';
      params = {
        ...params,
      };
    }

    const res = await axios.get(gameListUrl, {
      params
    });

    const { eventIds = [] } = res.data;

    dispatch({
      type: GET_POPULARORPERSONAL_EVENTS_SUCCESS,
      payload: { data: eventIds, isPersonal }
    });

    if (isPersonal && !eventIds?.length) { //sana özel'e istek atıp, boş array döndü ise otomatik popüler e dönülüyor.
      dispatch(getPopularOrPersonalEventsByTabType({ tabType, bulletinType }));
    }

  } catch (error) {
    dispatch({
      type: GET_POPULARORPERSONAL_EVENTS_FAILURE,
      payload: { isPersonal }
    });

    if (isPersonal) { //sana özel'e hata verirse, otomatik popüler e dönülüyor.
      dispatch(getPopularOrPersonalEventsByTabType({ tabType, bulletinType }));
    }
  }
};
